var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.84558 2.74391C8.20738 2.25986 8.6782 1.86792 9.21984 1.59991C9.76148 1.3319 10.3587 1.19535 10.963 1.20136H14.8234C15.8451 1.20136 16.8249 1.60723 17.5474 2.32968C18.2698 3.05214 18.6757 4.03199 18.6757 5.05369C18.6757 6.07539 18.2698 7.05525 17.5474 7.7777C16.8249 8.50015 15.8451 8.90602 14.8234 8.90602H10.963C10.0762 8.90558 9.21675 8.59922 8.52965 8.03865C7.84255 7.47808 7.36987 6.69762 7.19141 5.829",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1601 7.40319C12.9816 6.53457 12.5089 5.75412 11.8218 5.19355C11.1347 4.63298 10.2753 4.32662 9.38852 4.32617H5.52811C4.50641 4.32617 3.52655 4.73204 2.8041 5.45449C2.08165 6.17695 1.67578 7.1568 1.67578 8.1785C1.67578 9.2002 2.08165 10.1801 2.8041 10.9025C3.52655 11.625 4.50641 12.0308 5.52811 12.0308H9.38852C9.89368 12.0317 10.3941 11.933 10.8611 11.7404C11.3281 11.5478 11.7525 11.265 12.1102 10.9082C12.2417 10.7799 12.3607 10.6393 12.4655 10.4883",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.f9d73d1e8000b858b3e5c8b700547144.svg";
export { ForwardRef as ReactComponent };